import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { TProcessItem } from "@/comn/components/Process";

export const COMN_BASE = {
    path: `${lpcoEnvs.base}/`,
    api: `${process.env.REACT_APP_API_OSCI}/`,
    nodes: [
        // TODO 라벨 처리 필요
        { path: "/", label: "" },
    ],
    selectAppPtyList: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new/app-pty-list`, // Application Party List
    selectAppTrptInfo: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new/app-trpt-info`, // Application Transport Information
    selectAppInvcInfo: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new/app-invc-info`, // Application Invoice Information
    selectAppItmList: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new/app-itm-list`, // Application Item List
    selectAppItmInfo: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new/app-itm-info`, // Application Item Information
    selectAtcmList: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new/atcm-list`, // Attachment Files List
    selectAppAprvHistList: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new/app-aprv-hist`, // Application Approval History List
    selectAppFeeList: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new/fee-list`, // Application Fee List
    selectAppFeePayInfo: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new/fee-pay-info`, // Application Fee Payment Information
    selectAppExmpnTaxList: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/app/new/app-exmpn-tax`, // Application Exmeption Tax List
    selectCfgnPrcsInfo: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/cfgn/prcs/app-cd`, // Configuration Process Information
};

export const COMN_URLS = {
    esweBllInfoPpup: `${COMN_BASE.path}comn/ppup/esweBllInfoPpup`, // Bill Detail Popup !== 고지서 상세 정보 팝업 ==!
    esweRgstVrfnRsltPpup: `${COMN_BASE.path}comn/ppup/esweRgstVrfnRsltPpup`, // Register Verification Result Popup !== 심사 결과 등록 팝업 ==!
    esweRgstInscRsltPpup: `${COMN_BASE.path}comn/ppup/esweRgstInscRsltPpup`, // Register Inspection Result Popup !== 검사 결과 등록 팝업 ==!
    esweRgstAprvRsltPpup: `${COMN_BASE.path}comn/ppup/esweRgstAprvRsltPpup`, // Register Inspection Result Popup !== 승인 결과 등록 팝업 ==!
};

export const COMN_APIS = {
    // Get Application Party List !== 신청서 당사자 정보 조회 ==!
    getAppPtyList: (data: any) => {
        return api.get(`${COMN_BASE.selectAppPtyList}`, {
            params: data,
        });
    },
    // Get Application Transport Information !== 신청서 운송 정보 조회 ==!
    getAppTrptInfo: (data: any) => {
        return api.get(`${COMN_BASE.selectAppTrptInfo}`, {
            params: data,
        });
    },
    // Get Application Invoice Information !== 신청서 송장 정보 조회 ==!
    getAppInvcInfo: (data: any) => {
        return api.get(`${COMN_BASE.selectAppInvcInfo}`, {
            params: data,
        });
    },
    // Get Application Item List !== 신청서 품목 목록 조회 ==!
    getAppItmList: (data: any, page: number, size: number) => {
        return api.get(`${COMN_BASE.selectAppItmList}?page=${page}&size=${size}`, {
            params: data,
        });
    },
    // Get Application Item Information !== 신청서 품목 정보 조회 ==!
    getAppItmInfo: (data: any) => {
        return api.get(`${COMN_BASE.selectAppItmInfo}`, {
            params: data,
        });
    },
    // Get Attachment File List !== 첨부파일 목록 조회 ==!
    getAtcmList: (data: any, page: number, size: number) => {
        return api.get(`${COMN_BASE.selectAtcmList}?page=${page}&size=${size}`, {
            params: data,
        });
    },
    // Get Application Approval History List !== 신청서 승인 이력 조회 ==!
    getAppAprvhistList: (data: any, page: number, size: number) => {
        return api.get(`${COMN_BASE.selectAppAprvHistList}?page=${page}&size=${size}`, {
            params: data,
        });
    },
    // Get Application Fee List !== 신청서 수수료 목록 ==!
    getAppFeeList: (data: any) => {
        return api.get(`${COMN_BASE.selectAppFeeList}`, {
            params: data,
        });
    },
    // Get Application Fee Payment  Information !== 신청서 수수료 납부 정보 ==!
    getAppFeePayInfo: (data: any) => {
        return api.get(`${COMN_BASE.selectAppFeePayInfo}`, {
            params: data,
        });
    },
    // Get Application Exemption Tax List !== 신청서 면제 세금 목록 조회 ==!
    getAppExmpnTaxList: (data: any) => {
        return api.get(`${COMN_BASE.selectAppExmpnTaxList}`, {
            params: data,
        });
    },

    getCfgnPrcsInfo: (data: any) => {
        return api.get(`${COMN_BASE.selectCfgnPrcsInfo}`, {
            params: data,
        });
    },
};

export const SF_APP_DTL_PTY: TFormSchema = {
    id: "form_app_dtl_pty",
    schema: {
        ptyId: { type: "text", edit: false } /* Party UUID !== 당사자_UUID ==!*/,
        srtngOrd: { type: "text", edit: false } /* Party Sorting Order !== 당사자 정렬순서 ==!*/,
        ptyTpCd: { type: "text", edit: false } /* Party Type Code !== 당사자 유형코드 ==!*/,
        ptyTin: {
            type: "text",
            edit: false,
        } /* Party TIN !== 당사자 TIN ==!*/,
        ptyNm: { type: "text", edit: false } /* Party Name !== 당사자명 ==!*/,
        ptyCd: { type: "text", edit: false } /* Party Code(Tin/Name) !== 당사자_코드(Tin/Name) ==!*/,
        ptyCntyCd: {
            type: "text",
            edit: false,
        } /* Party Country Code !== 당사자 국가코드 ==!*/,
        ptyCntyNm: { type: "text", label: "L_CNTY", edit: false } /* Party Country Name !== 당사자 국가명 ==!*/,
        ptyPhysAddr: {
            type: "text",
            label: "L_POST_ADDR",
            edit: false,
        } /* Parth Physical address !== 당사자 물리주소 ==!*/,
        ptyPostDtlAddr: {
            type: "text",
            edit: true,
        } /* Party Post Detail Address !== 당사자 우편상세주소 ==!*/,
        ptyPostCd: {
            type: "text",
            edit: false,
        } /* Parth Post code !== 당사자 우편주소 ==!*/,
        ptyPostBaseAddr: {
            type: "text",
            edit: false,
        } /* Party Post Base Address !== 당사자 우편기본주소 ==!*/,
        ptyPostAddr: {
            type: "text",
            label: "L_PHYS_ADDR",
            edit: false,
        } /* Party Post Detail Address !== 당사자 우편상세주소 ==!*/,
        ptyEml: {
            type: "text",
            label: "L_EML",
            edit: false,
        } /* Party Email !== 당사자 이메일 ==!*/,
        ptyTelno: {
            type: "text",
            label: "L_TLPH_NO",
            edit: false,
        } /* Party Tel No !== 당사자 전화번호 ==!*/,
        ptyFaxNo: {
            type: "text",
            label: "L_FAX_NO",
            edit: false,
        } /* Party Fax No !== 당사자 팩스번호 ==!*/,
        wrhsCd: {
            type: "text",
            edit: false,
        } /* Party Warehouse Code !== 당사자 창고코드 ==!*/,
        wrhsNm: {
            type: "text",
            label: "L_WRHS",
            edit: false,
        } /* Party Warehouse Code !== 당사자 창고코드명 ==!*/,
        ptyCnttOfcrNm: {
            type: "text",
            label: "L_CNTT_NM",
            edit: false,
        } /* Party Contact Name !== 당사자 담당자명 ==!*/,
        ptyCnttOfcrTelno: {
            type: "text",
            label: "L_TLPH_NO",
            edit: false,
        } /* Party Contact Tel No !== 당사자 담당자 전화번호 ==!*/,
        ptyCnttOfcrEml: {
            type: "text",
            label: "L_EML",
            edit: false,
        } /* Parth Contact E-Mail !== 당사자 담당자 이메일 ==!*/,
    },
};

export const SF_APP_DTL_TRPT: TFormSchema = {
    id: "form_app_dtl_trpt",
    schema: {
        trptModeCd: {
            type: "text",
            edit: false,
        } /* Means of Transport !== 운송수단 ==!*/,
        trptModeNm: {
            type: "text",
            edit: false,
        } /* Transport Mode Code Name !== 수송_모드_코드명 ==!*/,
        trptMode: {
            type: "text",
            label: "L_TRPT_MEAN",
            edit: false,
        } /* Means of Transport !== 운송수단 ==!*/,
        trptMeanNm: {
            type: "text",
            label: "L_TRPT_NM",
            edit: false,
        } /* Transportation Name !== 운송수단명 ==!*/,
        trptMeanNo: {
            type: "text",
            label: "L_TRPT_NO",
            edit: false,
        } /* Transportation No. !== 운송수단번호 ==!*/,
        trptCoNm: {
            type: "text",
            label: "L_TRPT_CO",
            edit: false,
        } /* Transportation Company !== 운송회사 ==!*/,
        arvlPortCd: {
            type: "text",
            edit: false,
        } /* Port of Arrival !== 도착항구 ==!*/,
        arvlPortNm: {
            type: "text",
            edit: false,
        } /* Port of Arrival !== 도착항구명 ==!*/,
        arvlPort: {
            type: "text",
            label: "L_PORT_ARVL",
            edit: false,
        } /* Port of Arrival !== 도착항구명 ==!*/,
        arvlXptdDt: {
            type: "date",
            label: "L_ARVL_XPTD_DT",
            edit: false,
        } /* Expected Arrival Date !== 도착예정일자 ==!*/,
        dptrPortCd: {
            type: "text",
            edit: false,
        } /* Port of Departure !== 출발항구 ==!*/,
        dptrPortNm: {
            type: "text",
            edit: false,
        } /* Port of Departure !== 출발항구명 ==!*/,
        dptrPort: {
            type: "text",
            label: "L_PORT_DPTR",
            edit: false,
        } /* Port of Departure !== 출발항구 ==!*/,
        dptrXptdDt: {
            type: "date",
            label: "L_DPTR_XPTD_DT",
            edit: false,
        } /* Expected Departure Date !== 출발예정일자 ==!*/,
        cstmOfceCd: {
            type: "text",
            edit: false,
        } /* Customs Office !== 세관코드 ==!*/,
        cstmOfceNm: {
            type: "text",
            edit: false,
        } /* Customs Office !== 세관코드명 ==!*/,
        cstmOfce: {
            type: "text",
            label: "L_CSTM_OFCE",
            edit: false,
        } /* Customs Office !== 세관코드 ==!*/,
        blNo: { type: "text", label: "L_BL_NO_1", edit: false } /* BL No. !== BL번호 ==!*/,
    },
};

export const SG_APP_DTL_CNTR_LIST: TGridSchema = {
    id: "form_app_dtl_cntr_list",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 200,
    },
    head: [
        {
            cells: [{ header: "L_FRGH_IDCR", binding: "frghIdcrNm", width: "*" }],
            id: "frghIdcrNm",
        } /* Freight Indicator Code !== 운임_지표_코드 ==!*/,
        {
            cells: [{ header: "L_CNTR_SIZE", binding: "cntrSizeNm", width: "*" }],
            id: "cntrSizeNm",
        } /* Container Size Code !== 컨테이너_크기_코드*/,
        // {
        //     cells: [{ header: "L_CNTR_CNT", binding: "cntrCnt", width: "*" }],
        //     id: "cntrCnt",
        // } /* Container Count !== 컨테이너_건수*/,
        {
            cells: [{ header: "L_CNTR_NO", binding: "cntrNo", width: "*" }],
            id: "cntrNo",
        } /* Container Number !== 컨테이너_번호 ==!*/,
        {
            cells: [{ header: "L_SEAL_NO_1", binding: "sealNo1", width: "*" }],
            id: "sealNo1",
        } /* Seal Number 1 !== 봉인_번호_1 ==!*/,
        {
            cells: [{ header: "L_SEAL_NO_2", binding: "sealNo2", width: "*" }],
            id: "sealNo2",
        } /* Seal Number 2 !== 봉인_번호_2 ==!*/,
        {
            cells: [{ header: "L_SEAL_NO_3", binding: "sealNo3", width: "*" }],
            id: "sealNo3",
        } /* Seal Number 3 !== 봉인_번호_3 ==!*/,
    ],
    body: [
        {
            cells: [{ binding: "frghIdcrNm", type: "text", align: "left" }],
        },
        {
            cells: [{ binding: "cntrSizeNm", type: "text", align: "left" }],
        },
        // {
        //     cells: [
        //         {
        //             binding: "cntrCnt",
        //             align: "right",
        //             type: "number",
        //             thousandSeparator: true,
        //             decimalScale: 0,
        //         },
        //     ],
        // },
        {
            cells: [{ binding: "cntrNo", type: "text", align: "left" }],
        },
        {
            cells: [{ binding: "sealNo1", type: "text", align: "left" }],
        },
        {
            cells: [{ binding: "sealNo2", type: "text", align: "left" }],
        },
        {
            cells: [{ binding: "sealNo3", type: "text", align: "left" }],
        },
    ],
};

export const SF_APP_DTL_INVC: TFormSchema = {
    id: "form_app_dtl_invc",
    schema: {
        dlvrTermsCd: {
            type: "text",
            edit: false,
        } /* Delivery Term !== 인도조건 ==!*/,
        dlvrTermsNm: {
            type: "text",
            label: "L_DLVR_TERM",
            edit: false,
        } /* Delivery Term !== 인도조건 ==!*/,
        invcCurrCd: {
            type: "text",
            edit: false,
        } /* Currency !== 통화 ==!*/,
        invcCurrNm: {
            type: "text",
            label: "L_CURR",
            edit: false,
        } /* Currency !== 통화 ==!*/,
        invcExrt: {
            type: "number",
            label: "L_EXCG_RT",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: false,
        } /* Exchange Rate. !== 환율 ==!*/,
        currFcy: { type: "text", edit: false } /* Currency !== 통화(외화) ==!*/,
        fobVal: {
            type: "number",
            label: "L_FOB",
            size: "full",
            thousandSeparator: true,
            edit: false,
            decimalScale: 4,
            align: "right",
        } /* FOB !== FOB(외화) ==!*/,
        fobTzsVal: {
            type: "number",
            label: "L_FOB_NCY",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: false,
        } /* FOB (TZS) !== FOB(내화) ==!*/,
        frghVal: {
            type: "number",
            label: "L_FRGH",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: false,
        } /* Freight !== 운임(외화) ==!*/,
        frghTzsVal: {
            type: "number",
            label: "L_FRGH_NCY",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: false,
        } /* Freight (TZS) !== 운임(내화) ==!*/,
        insrVal: {
            type: "number",
            label: "L_INSR",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: false,
        } /* Insurance !== 보험(외화) ==!*/,
        insrTzsVal: {
            type: "number",
            label: "L_INSR_NCY",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: false,
        } /* Insurance (TZS) !== 보험(내화) ==!*/,
        othrCostVal: {
            type: "number",
            label: "L_OTHR_COST",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: false,
        } /* Other Costs !== 기타비용(외화) ==!*/,
        othrCostTzsVal: {
            type: "number",
            label: "L_OTHR_COST_NCY",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: false,
        } /* Other Costs (TZS) !== 기타비용(내화) ==!*/,
        cstmVal: {
            type: "number",
            label: "L_CSTM_VAL",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: false,
        } /* Customs Value !== 관세비용(외화) ==!*/,
        cstmUsdVal: {
            type: "number",
            label: "L_CSTM_VAL_FCY",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: false,
        } /* Customs Value (USD) !== 관세비용(USD) ==!*/,
        cstmTzsVal: {
            type: "number",
            label: "L_CSTM_VAL_NCY",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: false,
        } /* Customs Value (TZS) !== 관세비용(TZS) ==!*/,
    },
};

export const SG_APP_DTL_ITM_LIST: TGridSchema = {
    id: "form_app_dtl_itm_list",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "in", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: false, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 410,
    },
    head: [
        {
            cells: [{ header: "L_ITM_NO", binding: "rowItmNo", width: 100 }],
            id: "rowItmNo",
        } /* Item No !== 물품번호 ==!*/,
        { cells: [{ header: "L_HS", binding: "hsNm", width: "*" }], id: "hsNm" } /* HS !== HS ==!*/,
        {
            cells: [{ header: "L_ITM_DESC", binding: "itmDesc", width: "*" }],
            id: "itmDesc",
        } /* Item Description !== 물품설명 ==!*/,
        {
            cells: [{ header: "L_NWGHT", binding: "itmNwght", width: 120 }],
            id: "itmNwght",
        } /* Net Weight(KG) !== 순중량 ==!*/,
        {
            cells: [{ header: "L_GWGHT", binding: "itmGwght", width: 120 }],
            id: "itmGwght",
        } /* Gross Weight(KG) !== 총중량 ==!*/,
        {
            cells: [{ header: "L_ITM_PRC_NCY", binding: "itmTzsVal", width: 120 }],
            id: "itmTzsVal",
        } /* Item Price TZS !== 물품가격 ==!*/,
        {
            cells: [{ header: "L_UT_PRC_NCY", binding: "fobUtTzsVal", width: 120 }],
            id: "fobUtTzsVal",
        } /* Unit FOB TZS !== 단위 FOB ==!*/,
    ],
    body: [
        {
            cells: [{ binding: "rowItmNo", type: "text" }],
        },
        {
            cells: [{ binding: "hsNm", type: "text", align: "left" }],
        },
        {
            cells: [{ binding: "itmDesc", align: "left" }],
        },
        {
            cells: [{ binding: "itmNwght", align: "right", type: "number", thousandSeparator: true }],
        },
        {
            cells: [{ binding: "itmGwght", align: "right", type: "number", thousandSeparator: true }],
        },
        {
            cells: [{ binding: "itmTzsVal", align: "right", type: "number", thousandSeparator: true }],
        },
        {
            cells: [
                { binding: "fobUtTzsVal", align: "right", type: "number", thousandSeparator: true, decimalScale: 4 },
            ],
        },
    ],
};

export const SF_APP_DTL_ITM: TFormSchema = {
    id: "form_app_dtl_itm",
    schema: {
        rowItmNo: { type: "text", label: "L_ITM_NO", edit: false } /* Item No !== 조회용 물품번호 ==!*/,
        hsNm: {
            type: "text",
            label: "L_HS",
            edit: false,
        } /* HS !== 조회용 HS ==!*/,
        itmDesc: {
            type: "textarea",
            label: "L_ITM_DESC",
            edit: false,
        } /* Item Description. !== 조회용 물품설명 ==!*/,
        godsStatNm: {
            type: "text",
            label: "L_GODS_STAT",
            edit: false,
        } /* State of Goods !== 조회용 물품상태 ==!*/,
        itmQtyUtNm: {
            type: "text",
            edit: true,
        } /* Unit of Measure/Quantity !== 품목_수량_단위_코드 ==!*/,
        itmQty: {
            type: "number",
            thousandSeparator: true,
            decimalScale: 4,
            edit: true,
        } /* Unit of Measure/Quantity !== 조회용 품목_수량 ==!*/,
        itmSuppQtyUtNm: { type: "text", edit: true } /* Supplementary Quantity !== 조회용 보조수량 ==!*/,
        itmSuppQty: {
            type: "number",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: true,
        } /* Supplementary Quantity !== 조회용 품목_보완_수량 ==!*/,
        itmPckgUtNm: {
            type: "text",
            edit: true,
        } /* Package !== 조회용 품목_포장_단위_코드 ==!*/,
        itmPckgQty: {
            type: "number",
            size: "full",
            thousandSeparator: true,
            decimalScale: 0,
            edit: true,
        } /* Package !== 조회용 품목_포장_개수 ==!*/,
        origCntyNm: {
            type: "text",
            label: "L_CNTY_ORIG",
            edit: false,
        } /* Country of Origin !== 조회용 원산지 ==!*/,
        itmGwght: {
            type: "number",
            label: "L_GWGHT",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: false,
        } /* Gross Weight(kgs) !== 조회용 품목_총중량 ==!*/,
        itmNwght: {
            type: "number",
            label: "L_NWGHT",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: false,
        } /* New Weight(Kgs) !== 조회용 품목_순중량 ==!*/,
        currCd: { type: "text", edit: false } /* Currency !== 조회용 통화 ==!*/,
        currNm: { type: "text", label: "L_CURR", edit: false } /* Currency !== 조회용 통화 ==!*/,
        itmInvcExrt: {
            type: "number",
            label: "L_EXCG_RT",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: false,
        } /* Exchange Rate !== 조회용 품목_송장_환율 ==!*/,
        // currFcy: { type: "text", edit: false } /* Currency !== 조회용 통화(외화) ==!*/,
        fobUtVal: {
            type: "number",
            label: "L_UT_PRC",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: false,
        } /* Unit FOB !== 조회용 FOB_단위_가격 ==!*/,
        fobUtTzsVal: {
            type: "number",
            label: "L_UT_PRC_NCY",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: false,
        } /* Unit FOB (TZS) !== 조회용 FOB_단위_실링_가격 ==!*/,
        itmVal: {
            type: "number",
            label: "L_ITM_PRC",
            size: "full",
            thousandSeparator: true,
            decimalScale: 2,
            edit: false,
        } /* Item Price !== 조회용 품목_가격 ==!*/,
        itmTzsVal: {
            type: "number",
            label: "L_ITM_PRC_NCY",
            size: "full",
            thousandSeparator: true,
            decimalScale: 2,
            edit: false,
        } /* Item Price !== 조회용 품목_실링_가격 ==!*/,
        fobVal: {
            type: "number",
            label: "L_CSTM_VAL",
            size: "full",
            thousandSeparator: true,
            decimalScale: 2,
            edit: false,
        } /* FOB !== 조회용 FOB_가격 ==!*/,
        fobTzsVal: {
            type: "number",
            label: "L_CSTM_VAL_TZS",
            size: "full",
            thousandSeparator: true,
            decimalScale: 2,
            edit: false,
        } /* FOB (TZS) !== 조회용 FOB_실링_가격 ==!*/,
        rmrk: { type: "textarea", label: "L_RMRK", edit: false } /* Remark !== 조회용 비고 ==!*/,
    },
};

export const SF_APP_DTL_ITM_VHCL: TFormSchema = {
    id: "form_app_dtl_itm_vhcl",
    schema: {
        itmId: { type: "text", edit: false } /* Item Universally Unique Identifier !== 품목_UUID ==!*/,
        vhclId: { type: "text", edit: false } /* Vehicle Universally Unique Identifier !== 차량_UUID ==!*/,
        chssNo: { type: "text", label: "L_CHSS_NO", edit: false } /* Chassis Number !== 차대_번호 ==!*/,
        vhclMkerNm: {
            type: "text",
            label: "L_VHCL_MKER_CD",
            edit: false,
        } /* Vehicle Maker Code !== 차량_제조사_코드 ==!*/,
        vhclMkerMdlNm: {
            type: "text",
            label: "L_VHCL_MKER_MDL_CD",
            edit: false,
        } /* Vehicle Maker Model Code !== 차량_제조사_모델_코드 ==!*/,
        engnNo: {
            type: "text",
            label: "L_ENGN_NO",
            edit: false,
        } /* Engine Number !== 엔진_번호 ==!*/,
        vhclCtgrTpNm: {
            type: "text",
            label: "L_VHCL_CTGR_TP_CD",
            edit: false,
        } /* Vehicle Category Type Code !== 차량_카테고리_유형_코드 ==!*/,
        vhclClrKndNm: {
            type: "text",
            label: "L_VHCL_CLR_KND_CD",
            edit: false,
        } /* Vehicle Color Kind Code !== 차량_색상_종류_코드 ==!*/,
        vhclMnfcYy: {
            type: "text",
            label: "L_VHCL_MNFC_YY",
            edit: false,
        } /* Vehicle Manufacture Year !== 차량_제조_년도 ==!*/,
        vhclFlTpNm: {
            type: "text",
            label: "L_VHCL_FL_TP_CD",
            edit: false,
        } /* Vehicle Fuel Type Code !== 차량_연료_유형_코드 ==!*/,
        vhclTrmssnTpNm: {
            type: "text",
            label: "L_VHCL_TRMSSN_TP_CD",
            edit: false,
        } /* Vehicle Transmission Type Code !== 차량_변속기_유형_코드 ==!*/,
        cyldCnt: {
            type: "number",
            label: "L_CYLD_CNT",
            size: "full",
            thousandSeparator: true,
            decimalScale: 0,
            edit: false,
        } /* Cylinder Count !== 실린더_수 ==!*/,
        engnHpCapc: {
            type: "number",
            label: "L_ENGN_HP_CAPC",
            size: "full",
            thousandSeparator: true,
            decimalScale: 0,
            edit: false,
        } /* Engine Horsepower Capacity !== 엔진_마력_용량 ==!*/,
        doorsNo: {
            type: "number",
            label: "L_DOORS_NO",
            size: "full",
            thousandSeparator: true,
            decimalScale: 0,
            edit: false,
        } /* Doors Number !== 도어_개수 ==!*/,
        seatCapc: {
            type: "number",
            label: "L_SEAT_CAPC",
            size: "full",
            thousandSeparator: true,
            decimalScale: 0,
            edit: false,
        } /* Seat Capacity !== 좌석_용량 ==!*/,
        vhclMdlNoNm: {
            type: "text",
            label: "L_VHCL_MDL_NO_CD",
            edit: false,
        } /* Vehicle Model Number Name !== Vehicle Model Number Name ==! */,
        vhclPrplTpNm: {
            type: "text",
            label: "L_VHCL_PRPL_TP_CD",
            edit: false,
        } /* Vehicle Propeller Type Code Name !== Vehicle Propeller Type Code Name ==! */,
        vhclBodyTpNm: {
            type: "text",
            label: "L_VHCL_BODY_TP_CD",
            edit: false,
        } /* Vehicle Body Type Code Name !== Vehicle Body Type Code Name ==! */,
        vhclKndNm: {
            type: "text",
            label: "L_KND_VHCL",
            edit: false,
        } /* Vehicle Kind Code Name !== Vehicle Kind Code Name ==! */,
        vhclAxleNo: {
            type: "number",
            label: "L_AXLE_NO",
            edit: false,
        } /* Vehicle Axle Number !== Vehicle Axle Number ==! */,
        vhclDpacInfoCn: {
            type: "textarea",
            label: "L_VHCL_DPAC",
            edit: false,
        } /* Vehicle Displacement Information Contents !== Vehicle Displacement Information Contents ==! */,
    },
};

export const SF_APP_DTL_ITM_FRMS: TFormSchema = {
    id: "form_app_dtl_itm_frms",
    schema: {
        itmId: { type: "text", edit: false } /* Item Universally Unique Identifier !== 품목_UUID ==!*/,
        frmsId: { type: "text", edit: false } /* Fire_Arms Universally Unique Identifier !== 총기_UUID ==!*/,
        frmsAmtnClsfNm: {
            type: "text",
            label: "L_FIRE_ARMS_AMTN_CLSF_CD",
            edit: false,
        } /* Fire_Arms Ammunition Classification Code !== 총기_탄약_구분_코드 ==!*/,
        frmsTpNm: {
            type: "text",
            label: "L_FIRE_ARMS_TP_CD",
            edit: false,
        } /* Fire_Arms Type Code !== 총기_유형_코드 ==!*/,
        armsCabVal: {
            type: "number",
            label: "L_FIRE_ARMS_CAB_VAL",
            size: "full",
            thousandSeparator: true,
            decimalScale: 2,
            edit: false,
        } /* Arms Caliber Code !== 총기_구경_코드 ==!*/,
        judtPolNm: {
            type: "text",
            label: "L_JUDT_POL_NM",
            edit: false,
        } /* Jurisdiction Police Name !== 관할_경찰서_명 ==!*/,
        orgnCntyNm: {
            type: "text",
            label: "L_ORIG_CNTY",
            edit: false,
        } /* Original Country Code !== 원산지_국가_코드 ==!*/,
        frmsMkerNm: {
            type: "text",
            label: "L_FIRE_ARMS_MKER_NM",
            edit: false,
        } /* Fire_Arms Maker Name !== 총기_제조사_명 ==!*/,
        frmsLcneNo: {
            type: "text",
            label: "L_FIRE_ARMS_LCNE_NO",
            edit: false,
        } /* Fire_Arms License Number !== 총기_면허_번호 ==!*/,
        cfrRgsrNo: {
            type: "text",
            label: "L_CFR_RGSR_NO",
            size: "full",
            thousandSeparator: true,
            decimalScale: 0,
            edit: false,
        } /* Central Firearms Registry Registration Number !== CFR_등록_번호 ==!*/,
        armsMnfcNo: {
            type: "text",
            label: "L_FIRE_ARMS_MNFC_NO",
            edit: false,
        } /* Arms Manufacture Number !== 총기_제조_번호 ==!*/,
        frmsCstmRgsrNo: {
            type: "text",
            label: "L_FIRE_ARMS_CSTM_RGSR_NO",
            edit: false,
        } /* Fire_Arms Customs Registration Number !== 총기_세관_등록_번호 ==!*/,
        frmsRegnRgsrNo: {
            type: "text",
            label: "L_FIRE_ARMS_REGN_RGSR_NO",
            edit: false,
        } /* Fire_Arms Region Registration Number !== 총기_지역_등록_번호 ==!*/,
        pvtWrhsLcneNo: {
            type: "text",
            label: "L_PVT_WRHS_LCNE_NO",
            edit: false,
        } /* Private Warehouse License Number !== 개인_창고_면허_번호 ==!*/,
        pvtWrhsLcneHlpnNm: {
            type: "text",
            label: "L_PVT_WRHS_LCNE_HLPN_NM",
            edit: false,
        } /* Private Warehouse License Holder Name !== 개인_창고_면허_소유자_명 ==!*/,
        amtnQty: {
            type: "number",
            label: "L_AMTN_QTY",
            size: "full",
            thousandSeparator: true,
            decimalScale: 0,
            edit: false,
        } /* Ammunition Quantity !== 탄약_수량 ==!*/,
        amtnDesc: {
            type: "text",
            label: "L_AMTN_DESC",
            size: "full",
            thousandSeparator: true,
            decimalScale: 0,
            edit: false,
        } /* Ammunition Description !== 탄약_설명 ==!*/,
    },
};

export const SF_APP_DTL_ITM_SEED: TFormSchema = {
    id: "form_app_dtl_itm_seed",
    schema: {
        itmId: { type: "text", edit: false } /* Item Universally Unique Identifier !== 품목_UUID ==!*/,
        seedId: { type: "text", edit: false } /* Seed Universally Unique Identifier !== 종자_UUID ==!*/,
        cropNm: {
            type: "text",
            label: "L_CROP_NM",
            edit: false,
        } /* Crop Name !== 작물_명 ==!*/,
        vrtyNm: {
            type: "text",
            label: "L_VRTY_NM",
            edit: false,
        } /* Variety Name !== 품종_명 ==!*/,
        vrtyClsf: {
            type: "text",
            label: "L_VRTY_CLSF",
            edit: false,
        } /* Variety Classification !== 품종_등급 ==!*/,
        lotsNo: {
            type: "text",
            label: "L_LOTS_NO",
            edit: false,
        } /* LOTS Number !== LOTS_번호 ==!*/,
        vrtyQty: {
            type: "number",
            label: "L_SEED_QTY",
            size: "full",
            thousandSeparator: true,
            decimalScale: 0,
            edit: false,
        } /* Seed Quantity !== 품종_수량 ==!*/,
    },
};

export const SG_APP_DTL_ATCM_LIST: TGridSchema = {
    id: "form_app_dtl_atcm_list",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 400,
    },
    head: [
        { cells: [{ header: "L_DOC_TP", binding: "atcmTpNm", width: "*" }] } /* Document Type !== 문서유형 ==!*/,
        { cells: [{ header: "L_ATCD_FILE", binding: "atchFile", width: "*" }] } /* Attached File !== 첨부파일 ==!*/,
    ],
    body: [
        {
            cells: [{ binding: "atcmTpNm", type: "text", align: "left" }],
        },
        {
            cells: [
                {
                    binding: "bsopId",
                    type: "file",
                    align: "left",
                    bsopClsfCd: "OSC",
                    mode: "view",
                    required: true,
                },
            ],
        },
    ],
};

export const SG_APP_DTL_PAY_INFO_LIST: TGridSchema = {
    id: "form_app_dtl_pay_info_list",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "in", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 410,
    },
    head: [
        {
            cells: [{ header: "L_BLL_NO", binding: "bllNo", width: "*" }],
        } /* Control Number !== 조회용 컨트롤번호 ==!*/,
        { cells: [{ header: "L_FEE_TP", binding: "feeImpsTpNm", width: "*" }] } /* Fee Type !== 조회용 수수료타입 ==!*/,
        {
            cells: [{ header: "L_FEE_AMT_TZS", binding: "bllAmt", width: "*" }],
        } /* Amount !== 조회용 금액 ==!*/,
        {
            cells: [{ header: "L_STTS", binding: "feePrcssStatNm", width: "*" }],
        } /* Status !== 조회용 상태 ==!*/,
    ],
    body: [
        {
            cells: [{ binding: "bllNo", type: "text" }],
        },
        {
            cells: [{ binding: "feeImpsTpNm", type: "text" }],
        },
        {
            cells: [{ binding: "bllAmt", type: "number", thousandSeparator: true, decimalScale: 4 }],
        },
        {
            cells: [{ binding: "feePrcssStatNm" }],
        },
    ],
};

export const SF_APP_DTL_BILL_INFO: TFormSchema = {
    id: "form_app_dtl_bill_info",
    schema: {
        feeId: { type: "text", edit: false } /* Bill Status !== 조회용 고지서상태 ==!*/,
        bllNo: { type: "text", label: "L_BLL_NO", edit: false } /**  Bill Number !== 고지서_번호 ==! */,
        feePrcssStatNm: {
            type: "text",
            label: "L_BLL_STTS",
            edit: false,
        } /**  Fee Processing State Name !== 수수료_처리_상태_코드명 ==! */,
        bllIssDt: {
            type: "date",
            label: "L_BLL_ISS_DT1",
            edit: false,
        } /**  Bill Issue Date !== 고지서_발급_일자 ==! */,
        bllXpirDt: {
            type: "date",
            label: "L_PAY_DUE_DT_1",
            edit: false,
        } /**  Bill Expire Date !== 고지서_만료_일자 ==! */,
        feeImpsTpNm: {
            type: "text",
            label: "L_FEE_TP",
            edit: false,
        } /* Application Type. !== 조회용 신청서유형 ==!*/,
        bllAmt: {
            type: "number",
            label: "L_FEE_AMT_TZS",
            size: "full",
            thousandSeparator: true,
            decimalScale: 4,
            edit: false,
        } /* Freight (TZS) !== 운임(내화) ==!*/,
        payMetdNm: {
            type: "text",
            label: "L_PAY_METD",
            edit: false,
        } /**  Payment Methodology Code !== 납부_방법_코드 ==! */,
        payAmt: {
            type: "number",
            label: "L_PAY_AMT",
            edit: false,
            size: "full",
            decimalScale: 4,
            thousandSeparator: true,
        } /**  Payment Amount !== 납부_금액 ==! */,
        feePayDtm: {
            type: "date",
            label: "L_PAY_DTM",
            edit: false,
        } /**  Fee Payment Date and time !== 수수료_납부_일시 ==! */,
        rmrk: { type: "textarea", label: "L_RMRK", edit: false } /* Remark !== 조회용 Remark ==!*/,
    },
};

export const SG_APP_DTL_MSG_LIST: TGridSchema = {
    id: "form_app_dtl_msg_list",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: false, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 410,
    },
    head: [
        {
            cells: [{ header: "L_NTC_DT", binding: "ntcDt", width: 200 }],
        } /* Notice Date !== 조회용 공지일자 ==!*/,
        { cells: [{ header: "L_STTS", binding: "stts", width: 200 }] } /* Status !== 조회용 상태 ==!*/,
        {
            cells: [{ header: "L_MSG_CN", binding: "msgCn", width: "*" }],
            id: "msgCn",
        } /* Message !== 조회용 메시지 ==!*/,
    ],
    body: [
        {
            cells: [{ binding: "ntcDt", type: "text" }],
        },
        {
            cells: [{ binding: "stts", type: "text" }],
        },
        {
            cells: [{ binding: "msgCn" }],
        },
    ],
};

export const SG_APP_APRV_HIST_LIST: TGridSchema = {
    id: "form_app_aprv_hist_list",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "in", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: "DESC", // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 410,
    },
    head: [
        {
            cells: [{ header: "L_OGA", binding: "orgAbrtNm", width: "*" }],
            id: "orgAbrtNm",
        } /* Status !== 조회용 상태 ==!*/,
        {
            cells: [{ header: "L_STTS", binding: "prcssStatNm", width: 200 }],
            id: "prcssStatNm",
        } /* Status !== 조회용 상태 ==!*/,
        {
            cells: [{ header: "L_PRCSS_STAT", binding: "ofcrTpNm", width: 200 }],
            id: "ofcrTpNm",
        } /* Status !== 조회용 상태 ==!*/,
        {
            cells: [{ header: "L_OFCR_NM", binding: "ofcrNm", width: 200 }],
            id: "ofcrNm",
        } /* Status !== 조회용 상태 ==!*/,
        {
            cells: [{ header: "L_PRCS_DT", binding: "ofcrPrcssDtm", width: 200 }],
            id: "ofcrPrcssDtm",
        } /* Process Date !== 조회용 처리일자 ==!*/,
        {
            colspan: 2,
            cells: [{ header: "L_CNNT", binding: "cnnt", width: "*", colspan: 2 }],
        } /* Content !== 조회용 내용 ==!*/,
    ],
    body: [
        {
            cells: [{ binding: "orgAbrtNm", type: "text", align: "center", rowspan: 2 }],
        },
        {
            cells: [{ binding: "prcssStatNm", type: "text", align: "center", rowspan: 2 }],
        },
        {
            cells: [{ binding: "ofcrTpNm", type: "text", align: "center", rowspan: 2 }],
        },
        {
            cells: [{ binding: "ofcrNm", type: "text", align: "center", rowspan: 2 }],
        },
        {
            cells: [{ binding: "ofcrPrcssDtm", type: "text", align: "center", rowspan: 2 }],
        },
        {
            colspan: 2,
            cells: [
                { binding: "prcssRsnNm", type: "text", align: "left" },
                { binding: "prcssRsnCn", type: "text", align: "left" },
                { binding: "aprvRmrk", type: "text", align: "left" },
                { binding: "rmrk", type: "text", align: "left" },
            ],
        },
    ],
};

export const SF_OGA_SRCH_PPUP_COND: TFormSchema = {
    id: "form_oga_srch_ppup_cond",
    schema: {
        orgNm: { type: "text", label: "L_OGA_NM", edit: true } /* OGA Name !== 출력용 OGA 이름 ==!*/,
    },
};

export const SG_OGA_SRCH_PPUP_LST: TGridSchema = {
    id: "form_oga_srch_ppup_lst",
    options: {
        radio: false, // 라디오 버튼 보이기/숨기기 , default : false
        checkbox: false, //체크박스 보이기 숨기기, default : false
        pagination: "out", // 그리드 데이터 페이징 "out" : 데이터를 외부에서 페이징해서 가져오는 경우 , "in" : 데이터를 전체 가져와서 그리드 내부에서 페이징 및 편집
        index: true, // 그리드 번호  index : true ( asc )  , index : "DESC" ( desc 역순 )
        edit: false, // 그리드 편집 가능 여부 , default : false
        height: 400,
    },
    head: [
        {
            cells: [{ header: "L_OGA_CD", binding: "orgCd", width: 100 }],
            id: "orgCd",
        } /* OGA Code !== 출력용 OGA Code ==!*/,
        {
            cells: [{ header: "L_OGA_NM", binding: "orgNm", width: "*" }],
            id: "orgNm",
        } /* OGA Name !== 출력용 OGA 이름 ==!*/,
        {
            cells: [{ header: "L_OGA_TLPH_NO", binding: "rprsTelNo", width: 150 }],
            id: "rprsTelNo",
        } /* OGA Tel No !== 출력용 OGA 전화번호 ==!*/,
        {
            cells: [{ header: "L_OGA_ADDR", binding: "physAddr", width: "*" }],
            id: "physAddr",
        } /* OGA Address !== 출력용 OGA 주소 ==!*/,
    ],
    body: [
        {
            cells: [{ binding: "orgCd", type: "text" }],
        },
        {
            cells: [{ binding: "orgNm", type: "text", align: "left" }],
        },
        {
            cells: [{ binding: "rprsTelNo", type: "text" }],
        },
        {
            cells: [{ binding: "physAddr", type: "text", align: "left" }],
        },
    ],
};

export const SF_APP_DTL_ADD_ITM: TFormSchema = {
    id: "form_app_dtl_add_itm",
    schema: {},
};

export const SF_APP_DTL_EXMPN_TAX: TFormSchema = {
    id: "form_app_dtl_exmpn_tax",
    schema: {
        taxId: {
            type: "text",
            edit: false,
        } /* Tax Universally Unique Identifier !== 세금_UUID ==! */,
        orgCd: {
            type: "text",
            edit: false,
        } /* Organization Code !== 기관_코드 ==!*/,
        srtngOrd: {
            type: "text",
            edit: false,
        } /* Sorting Order !== 정렬_순서 ==!*/,
        exmpnTaxTpCd: {
            type: "checkbox",
            label: "L_EXMPN_TAX_TP",
            area: "comnCd",
            comnCd: "OSC0142",
            edit: false,
        } /* Exemption Tax Type Code !== 면제_세금_유형_코드 ==!*/,
    },
};

/*
 * @ T_PRCS_STTS_ITEM
 * @ 상태를 보여주는 Status CSS 에 사용
 * @ 공통함수를 사용하므로 제일 긴 문자열에 맞추기 위해 Description 활용
 */
export const T_PRCS_STTS_ITEM: TProcessItem[] = [
    { icon: "start", title: "Draft", description: "                                 " },
    { icon: "inProgress", title: "Submitted", description: "                                 " },
    { icon: "inProgress", title: "Received", description: "                                 " },
    { icon: "inProgress", title: "Verifying", description: "                                 " },
    {
        icon: "inProgress",
        title: "Final Verifying",
        description: "                                 ",
    },
    { icon: "inProgress", title: "Inspecting" },
    { icon: "inProgress", title: "Final Reviewing" },
    { icon: "inProgress", title: "Fee Payment", description: "                                 " },
    { icon: "completed", title: "Approved" },
];
